import React from "react";
import { Box, Typography } from "@mui/material";
import { T, SERIES_SOFT } from "utils/backrrTokens";
import BarRow from "./BarRow";

// Ranked list for one dimension. Borderless by design — BreakdownPanel draws
// the single surface and the hairlines between columns, so this renders only
// its own content.
//
// All rows share one hue: the bar's length already encodes magnitude, so
// varying hue per row would be decoration. And these are deliberately not
// pie charts — a startup may hold several stages or sectors, so the counts do
// not sum to the startup total and a part-to-whole chart would assert
// something false.
const BreakdownBars = ({ title, block, isLoading, tint = SERIES_SOFT[0] }) => {
  if (isLoading) return <Box className="skeleton" sx={{ height: "14rem", margin: "12px", borderRadius: "8px" }} />;

  const rows = block?.rows ?? [];
  const all = block?.other > 0 ? [...rows, { label: "Other", count: block.other, muted: true }] : rows;
  const max = all.reduce((m, r) => Math.max(m, r.count), 0);

  return (
    <Box sx={{ padding: "12px 8px", minWidth: 0 }}>
      <Typography
        sx={{ fontSize: "0.85rem", fontWeight: 600, paddingLeft: "8px", marginBottom: 0.75 }}
        color={T.ink}
      >
        {title}
      </Typography>

      {all.length === 0 ? (
        <Typography padding={3} textAlign="center" fontSize="0.78rem" color={T.inkSubtle}>
          No startups in this range.
        </Typography>
      ) : (
        <>
          {all.map((r) => (
            <BarRow
              key={r.label}
              label={r.label}
              count={r.count}
              max={max}
              color={tint}
              muted={r.muted}
            />
          ))}
          <Typography
            sx={{ fontSize: "0.72rem", paddingLeft: "8px", marginTop: 1 }}
            color={T.inkSubtle}
          >
            {block?.total ?? 0} startups
            {block?.multi_valued ? " · may hold more than one" : ""}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default BreakdownBars;
